import React, { useCallback, useEffect, useState } from "react";
import LayoutBase from "./LayoutBase";
import { Button, Col, Radio, Row, Select } from "antd";
import {
  HomeOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import ConfirmModal from "./ConfirmModal";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import {
  FormRegister,
  initialServiceAndItem,
  ErrosFIleUpload,
  FIleUpload,
  initailErrors,
  initialFileUpload,
  Files,
  Errors,
  ResponseDataBalckList,
  ServiceAndItem,
} from "./RegisterModel";
import {
  Provinces,
  Districes,
  States,
} from "../../Services/e-pro/models/RegisterModel";
import {
  CheckBlackListForm,
  GetAllAddress,
  GetDistriceById,
  GetProvinceById,
  GetStateById,
  SaveUserToDatabase,
} from "../../Services/e-pro/RegisterService";
import {
  GetAllBlackList,
  GetAllServiceAndItem,
} from "../../Services/e-pro/CatalogMasterDataService";
import IndividualBlackListModal from "./IndividualBlackListModal";
import { generateQuickGuid } from "../../Helper/GenerateGuid";
import { UploadFileAttachFiles, UploadFileAttachFiles_v2 } from "../../Services/AttachFileService";
import { useHistory } from "react-router";
import Swal from "sweetalert2";
import {
  OpenApiMemorandumSeller,
  OpenApiRegister,
} from "../../Services/e-pro/OpenApiEproService";
import { OptionList } from "../../Services/e-pro/models/ServiceAndItemModel";
import { SupplierDetail } from "../../Services/e-pro/models/SupplierModel";
import { useSessionContext } from "../../Context/AuthContext";
import { useUserContext } from "../../Context/UserContext";
import { CheckRolePermission } from "../../Services/AuthorizedService";
import { DataAndPermission } from "../ScreenGeneral/SupplierListDetail";
import OTPModal from "../LoginScreen/OTPModal";
import { requestOTPAndSaveToDb } from "../../Services/e-pro/SupplierService";
type Props = {
  sellerDetail?: SupplierDetail;
};
const RegisterIndividualScreen = ({ sellerDetail }: Props) => {
  const [showDailogConfirm, setShowDailogConfirm] = useState<boolean>(false);
  const [fileList, setFileList] = useState<FIleUpload>(initialFileUpload);
  const [showFiles, setshowFiles] = useState<FIleUpload>(initialFileUpload);
  const [errosSize, setErrosSize] = useState<ErrosFIleUpload>(initailErrors);
  const [showModalOtp, setShowModalOtp] = useState<boolean>(false);
  const [provinces, setProvinces] = useState<Provinces[]>();
  const [distrinces, setDistrinces] = useState<Districes[]>();
  const [statees, setStates] = useState<States[]>();
  const [dataOTP, setDataOTP] = useState<any>();
  const [post, setPost] = useState<number>();
  const [blackList, setBlackList] = useState<BlackListData[]>([]);
  const [showDailogBlackList, setShowDailogBlackList] =
    useState<boolean>(false);
  const [category, setCategory] = useState<string[]>();
  const [item, setItem] = useState<OptionList[]>();
  const [isAdmin, serIsAdmin] = React.useState(false);
  const [sessionContext] = useSessionContext();
  const [confirmOTP, setConfirmOTP] = useState();
  const [userData] = useUserContext();
  const history = useHistory();

  const {
    control,
    register,
    handleSubmit,
    clearErrors,
    setError,
    watch,
    getValues,
    reset,
    formState: { errors },
    setValue,
  } = useForm<FormRegister>({
    defaultValues: { ServiceAndItem: initialServiceAndItem },
  });

  const {
    fields: serviceField,
    remove: removeService,
    append: appenService,
  } = useFieldArray({ control, name: "ServiceAndItem" });

  const getRolePermission = async () => {
    const employeeId = localStorage.getItem("employeeId") ?? null;
    if (employeeId) {
      const isAdmin = await CheckRolePermission(Number(employeeId));
      console.log("isAdmin = ", isAdmin);
      serIsAdmin(isAdmin);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await GetAllAddress();
      const blackList = await GetAllBlackList();
      const serviceAndItem = await GetAllServiceAndItem();
      setBlackList(blackList.data);
      setProvinces(response.Data);
      setCategory(serviceAndItem.data.category);
      setItem(serviceAndItem.data.options);
    };
    fetchData();
    getRolePermission();
  }, []);

  const permissionData: DataAndPermission = {
    isAuthenticated: sessionContext?.isAuthenticated,
    isAdmin: isAdmin,
    isSeller: userData?.EmployeeCode?.toUpperCase().startsWith("SELL"),
  };

  useEffect(() => {
    if (sellerDetail && permissionData?.isAuthenticated) {
      setValue("SellerNameTh", sellerDetail?.SellerName);
      setValue("SellerRegisterType", sellerDetail?.SellerRegisterType);
      setValue("SellerStatus", sellerDetail?.SellerStatus);
      setValue("IdentificationNo", sellerDetail?.IdentificationNo);
      setValue("DateOfRegisteration", sellerDetail?.DateOfRegisteration);
      setValue("RegisteredCapital", sellerDetail?.RegisteraedCapital);
      setValue("MobilePhone", sellerDetail.MobilePhone);
      setValue("BussniesType", sellerDetail?.BussniesType);
      setValue("TaxpayerIdentificationNo", sellerDetail?.TaxpayerIdentificationNo);
      setValue("Region", sellerDetail?.Region);
      setValue("Buildings", sellerDetail?.Building);
      setValue("Room", sellerDetail?.Room);
      setValue("Floor", sellerDetail?.Floor);
      setValue("Village", sellerDetail?.Village);
      setValue("HouseNo", sellerDetail?.HouseNo);
      setValue("Swine", sellerDetail?.Swine);
      setValue("Alley", sellerDetail?.Alley);
      setValue("Road", sellerDetail?.Road);
      setValue("Province", sellerDetail?.Province);
      setValue("State", sellerDetail?.State);
      setValue("Districe", sellerDetail?.Districe);
      setValue("Post", sellerDetail?.Post);
      setValue("ContactName", sellerDetail?.ContactName);
      if (sellerDetail?.PhoneNumber != null) {
        const splitePhoneNumber = sellerDetail?.PhoneNumber?.split(" ");
        if (splitePhoneNumber[0]) setValue("PhoneNumber", splitePhoneNumber[0]);
        if (splitePhoneNumber[2]) setValue("Per", splitePhoneNumber[2]);
      }
      setValue("Email", sellerDetail?.Email);
      setValue("DigitalContact", sellerDetail?.DigitalContact);
      setValue("OtherService", sellerDetail?.OtherService);
      setValue(`deliveryDate.capital`, sellerDetail.SendDateBkkArea);
      setValue(`deliveryDate.provincial`, sellerDetail.SendDateOtherArea);
      if (
        sellerDetail?.CertOfCompletion != null &&
        sellerDetail?.CertOfCompletion.length > 0
      ) {
        setValue(`CertOfCompletion`, sellerDetail?.CertOfCompletion);
        showFileList({
          CertOfCompletion: sellerDetail?.CertOfCompletion.map((item) => {
            return { name: item, file: undefined };
          }),
        });
      }
      if (
        sellerDetail?.Certificate != null &&
        sellerDetail?.Certificate.length > 0
      ) {
        setValue(`Certificate`, sellerDetail?.Certificate);
        showFileList({
          Certificate: sellerDetail?.Certificate.map((item) => {
            return { name: item, file: undefined };
          }),
        });
      }
      if (
        sellerDetail?.ExceptionDetail != null &&
        sellerDetail?.ExceptionDetail.length > 0
      ) {
        setValue(`ExceptionDetail`, sellerDetail?.ExceptionDetail);
        showFileList({
          ExceptionDetail: sellerDetail?.ExceptionDetail.map((item) => {
            return { name: item, file: undefined };
          }),
        });
      }

      if (sellerDetail?.LogoPath != null) {
        setValue(`LogoPath.${0}`, sellerDetail?.LogoPath);
        showFileList({
          LogoPath: [{ name: sellerDetail.LogoPath, file: undefined }],
        });
      }
      if (sellerDetail?.CatalogFilePath != null) {
        setValue(`CatalogFilePath.${0}`, sellerDetail?.CatalogFilePath);
        showFileList({
          CatalogFilePath: [
            { name: sellerDetail.CatalogFilePath, file: undefined },
          ],
        });
      }
      if (
        sellerDetail?.ServiceAndItem != null &&
        sellerDetail?.ServiceAndItem.length > 0
      ) {
        removeService(0);
        sellerDetail?.ServiceAndItem?.forEach((item) => {
          appenService({
            ServiceItemType: item.ServiceType,
            ServiceItemID: item.ServiceItemName,
          });
        });
      }
    }
  }, [sellerDetail, permissionData?.isAuthenticated, setValue]);

  const watchProvince = watch("Province");
  useEffect(() => {
    const getProvince = async () => {
      const value = watch("Province");
      const response = await GetProvinceById(value);
      if (response) {
        setDistrinces(response.Districes);
      }
    };
    getProvince();
  }, [watchProvince]);

  const watchDistrice = watch("Districe");
  useEffect(() => {
    const getDistrice = async () => {
      const value = watch("Districe");
      const response = await GetDistriceById(value);
      if (response) {
        setStates(response.States);
      }
    };
    getDistrice();
  }, [watchDistrice]);
  const watchState = watch("State");
  useEffect(() => {
    const getState = async () => {
      const value = watch("State");
      const response = await GetStateById(value);
      if (response) {
        setPost(response.Post);
        setValue("Post", JSON.stringify(response.Post));
      }
    };
    getState();
  }, [watchState]);

  useEffect(() => {
    if (watch("SellerStatus") !== "AVL-C") {
      clearErrors("deliveryDate.capital");
      clearErrors("deliveryDate.provincial");
    }
  }, [watch("SellerStatus")]);

  const openConfirmDailog = useCallback(() => {
    setShowDailogConfirm(true);
  }, []);

  const cancelDailog = useCallback(() => {
    setShowDailogConfirm(false);
  }, []);

  const submitAndOpenForm = async (formModel: any) => {
    // Start 
    // Upload File To Server 
    // Check Permission Save 
    // Edit Or Register 
    // ------- if Edit -------
    // 
    // ------- if Register ------
    // Save Date Form Screen To DataBase
    // --if Success -- Open Memorundum 
    // --if Memorundum Success --- Alert Popup Success
    // --Else Go Remove Seller From DataBase -- Alert Popup Failed
    // --Else -- Go Remove Seller From DataBase -- Alert Popup Failed
    // End 

    // Upload File To Server
    const result = await upload(formModel);
    formModel.ExceptionDetail = result.ExceptionDetail.map((data: any) => ({
      FileName: data.fileName,
      Path: data.pathUrl,
    }));
    formModel.Certificate = result.Certificate.map((data: any) => ({
      FileName: data.fileName,
      Path: data.pathUrl,
    }));
    formModel.CertOfCompletion = result.CertOfCompletion.map((data: any) => ({
      FileName: data.fileName,
      Path: data.pathUrl,
    }));
    formModel.LogoPath = result.LogoPath.map((data: any) => ({
      FileName: data.fileName,
      Path: data.pathUrl,
    }));
    formModel.CatalogFilePath = result.CatalogFilePath.map((data: any) => ({
      FileName: data.fileName,
      Path: data.pathUrl,
    }));
    let mapFormToValue: { [name: string]: string } = {
      "ชื่อผู้ประกอบการ/ชื่อร้านค้า": "SellerNameTh",
      เลขประจำตัวผู้เสียภาษีอากร: "TaxpayerIdentificationNo",
      ประเภทผู้ค้า: "SellerRegisterType",
      ประเภทกิจการ: "BussniesType",
      เลขประจำตัวประชาชน: "IdentificationNo",
      "หมายเลขโทรศัพท์ (สำหรับยืนยันตัวตน)": "MobilePhone",
      ที่ตั้งสำนักงานใหญ่: "Region",
      ชื่ออาคาร: "Buildings",
      ห้องเลขที่: "Room",
      ชั้นที่: "Floor",
      ชื่อหมู่บ้าน: "Village",
      เลขที่: "HouseNo",
      หมู่ที่: "Swine",
      "ตรอก/ซอย": "Alley",
      ถนน: "Road",
      จังหวัด: "Province",
      "อำเภอ/เขต": "State",
      "ตำบล/แขวง": "Districe",
      รหัสไปรษณีย์: "Post",
      ชื่อผู้ติดต่อ: "ContactName",
      หมายเลขโทรศัพท์: "PhoneNumber",
      "E-mail": "Email",
      "ช่องทางการประชาสัมพันธ์ (Website, Facebook,อื่นๆ)": "DigitalContact",
      "ประวัติการได้รับข้อยกเว้น (ทางกฎหบาย หรือ เอกสิทธิ์พิเศษ ทางกฎหมาย หรือ ประวัติการติดบัญชีรายชื่อผู้ทั้งงาน)":
        "ExceptionDetail",
      "แนบใบรับรอง เช่น Regulation Certified, Certificate, Document, ISO":
        "Certificate",
      แนบหนังสือรับรองผลงาน: "CertOfCompletion",
      รูปโลโก้ร้านค้า: "LogoPath",
      "ประเภทสินค้า/บริการ": "ServiceAndItem",
      "ข้อมูลสินค้า/บริการ": "OtherService",
      "แนบไฟล์ Catalog แนบไฟล์": "CatalogFilePath",
      ปรับสถานะผู้ค้า: "SellerStatus",
      Mode: "Mode",
      SellerCode: "SellerCode",
      กรุงเทพและปริมณฑล: "Capital",
      ต่างจังหวัด: "Provincial",
    };
    // Get Template From OpenAPI
    let resultOpenApi = await OpenApiRegister("RC-บุคคลธรรมดา");
    resultOpenApi.subject = `${resultOpenApi.subject} ${formModel.SellerNameTh}`;
    resultOpenApi.userPrincipalName = sessionContext.isAuthenticated
      ? userData?.Email
      : undefined;
    resultOpenApi.form = resultOpenApi.form.map((item) => {
      let value = mapFormToValue[item.template.label];
      if (
        value != null &&
        (value == "Certificate" ||
          value == "CertOfCompletion" ||
          value == "ExceptionDetail" ||
          value == "CatalogFilePath")
      ) {
        item.data.row = formModel[value]?.map((data: any) => {
          let newRow = [{ value: data.Path }];
          return newRow;
        });
      } else if (value != null && value == "LogoPath") {
        item.data.value =
          formModel["LogoPath"] != null && formModel["LogoPath"].length > 0
            ? formModel["LogoPath"][0].Path
            : "";
      } else {
        item.data.value = formModel[value];
      }
      if (item.template.label == "ประเภทสินค้า/บริการ") {
        let arrayService: string[] = [];
        formModel["ServiceAndItem"]?.forEach((data: any) => {
          arrayService.push(data.ServiceItemID);
        });
        item.data.value = arrayService.join() ?? "";
      }
      return item;
    });
    if (permissionData?.isAuthenticated && permissionData.isAdmin || permissionData?.isAuthenticated && permissionData.isSeller) {
      // Case Edit And Open Fourm
      const openForm = await OpenApiMemorandumSeller(resultOpenApi);
      if (openForm) {
        Swal.fire({
          title: "ส่งข้อมูลสำเร็จ",
          icon: "success",
          confirmButtonText: `ยืนยัน`,
          confirmButtonColor: "#6598F6",
        }).then(() => {
          if (permissionData?.isAuthenticated && permissionData.isAdmin) {
            history.push("/Supplierlist");
          } else {
            history.go(0);
          }
        });
      } else {
        Swal.fire({
          title: "ส่งข้อมูลไม่สำเร็จ",
          icon: "error",
          confirmButtonText: `ยืนยัน`,
          confirmButtonColor: "#6598F6",
        });
      }
    } else {
      // Case New Register
      formModel.ExceptionDetail = formModel.ExceptionDetail?.map(
        (data: any) => data.Path
      );
      formModel.Certificate = formModel.Certificate?.map(
        (data: any) => data.Path
      );
      formModel.CertOfCompletion = formModel.CertOfCompletion?.map(
        (data: any) => data.Path
      );
      formModel.LogoPath =
        formModel.LogoPath != null && formModel.LogoPath.length > 0
          ? formModel.LogoPath[0].Path
          : "";
      formModel.CatalogFilePath = formModel.CatalogFilePath?.map(
        (data: any) => data.Path
      );

      const resultSave = await SaveUserToDatabase(formModel, "Individual");
      if (resultSave.code === "200") {
        const openForm = await OpenApiMemorandumSeller(resultOpenApi);
        if (openForm) {
          Swal.fire({
            title: "ส่งข้อมูลสำเร็จ",
            icon: "success",
            confirmButtonText: `ยืนยัน`,
            confirmButtonColor: "#6598F6",
          }).then(() => {
            history.push("/login");
          });
        } else {
          // Remove Seller From DataBase
          const resultRemove = await SaveUserToDatabase(formModel, "Delete");
          Swal.fire({
            icon: "error",
            title: resultSave.message,
            confirmButtonText: `ยืนยัน`,
            confirmButtonColor: "#6598F6",
          });
        }
      } else {
        Swal.fire({
          title: "ส่งข้อมูลไม่สำเร็จ",
          icon: "error",
          confirmButtonText: `ยืนยัน`,
          confirmButtonColor: "#6598F6",
        });
      }
    }




    //----------------------------------------------------------------//
    // const result = await upload(formModel);
    // formModel.ExceptionDetail = result.ExceptionDetail.map((data: any) => ({
    //   FileName: data.fileName,
    //   Path: data.pathUrl,
    // }));
    // formModel.Certificate = result.Certificate.map((data: any) => ({
    //   FileName: data.fileName,
    //   Path: data.pathUrl,
    // }));
    // formModel.CertOfCompletion = result.CertOfCompletion.map((data: any) => ({
    //   FileName: data.fileName,
    //   Path: data.pathUrl,
    // }));
    // formModel.LogoPath = result.LogoPath.map((data: any) => ({
    //   FileName: data.fileName,
    //   Path: data.pathUrl,
    // }));
    // formModel.CatalogFilePath = result.CatalogFilePath.map((data: any) => ({
    //   FileName: data.fileName,
    //   Path: data.pathUrl,
    // }));
    // let mapFormToValue: { [name: string]: string } = {
    //   "ชื่อผู้ประกอบการ/ชื่อร้านค้า": "SellerNameTh",
    //   เลขประจำตัวผู้เสียภาษีอากร: "TaxpayerIdentificationNo",
    //   ประเภทผู้ค้า: "SellerRegisterType",
    //   ประเภทกิจการ: "BussniesType",
    //   เลขประจำตัวประชาชน: "IdentificationNo",
    //   "หมายเลขโทรศัพท์ (สำหรับยืนยันตัวตน)": "MobilePhone",
    //   ที่ตั้งสำนักงานใหญ่: "Region",
    //   ชื่ออาคาร: "Buildings",
    //   ห้องเลขที่: "Room",
    //   ชั้นที่: "Floor",
    //   ชื่อหมู่บ้าน: "Village",
    //   เลขที่: "HouseNo",
    //   หมู่ที่: "Swine",
    //   "ตรอก/ซอย": "Alley",
    //   ถนน: "Road",
    //   จังหวัด: "Province",
    //   "อำเภอ/เขต": "State",
    //   "ตำบล/แขวง": "Districe",
    //   รหัสไปรษณีย์: "Post",
    //   ชื่อผู้ติดต่อ: "ContactName",
    //   หมายเลขโทรศัพท์: "PhoneNumber",
    //   "E-mail": "Email",
    //   "ช่องทางการประชาสัมพันธ์ (Website, Facebook,อื่นๆ)": "DigitalContact",
    //   "ประวัติการได้รับข้อยกเว้น (ทางกฎหบาย หรือ เอกสิทธิ์พิเศษ ทางกฎหมาย หรือ ประวัติการติดบัญชีรายชื่อผู้ทั้งงาน)":
    //     "ExceptionDetail",
    //   "แนบใบรับรอง เช่น Regulation Certified, Certificate, Document, ISO":
    //     "Certificate",
    //   แนบหนังสือรับรองผลงาน: "CertOfCompletion",
    //   รูปโลโก้ร้านค้า: "LogoPath",
    //   "ประเภทสินค้า/บริการ": "ServiceAndItem",
    //   "ข้อมูลสินค้า/บริการ": "OtherService",
    //   "แนบไฟล์ Catalog แนบไฟล์": "CatalogFilePath",
    //   ปรับสถานะผู้ค้า: "SellerStatus",
    //   Mode: "Mode",
    //   SellerCode: "SellerCode",
    //   กรุงเทพและปริมณฑล: "Capital",
    //   ต่างจังหวัด: "Provincial",
    // };
    // let resultOpenApi = await OpenApiRegister("RC-บุคคลธรรมดา");
    // resultOpenApi.subject = `${resultOpenApi.subject} ${formModel.SellerNameTh}`;
    // resultOpenApi.userPrincipalName = sessionContext.isAuthenticated
    //   ? userData?.Email
    //   : undefined;
    // resultOpenApi.form = resultOpenApi.form.map((item) => {
    //   let value = mapFormToValue[item.template.label];
    //   if (
    //     value != null &&
    //     (value == "Certificate" ||
    //       value == "CertOfCompletion" ||
    //       value == "ExceptionDetail" ||
    //       value == "CatalogFilePath")
    //   ) {
    //     item.data.row = formModel[value]?.map((data: any) => {
    //       let newRow = [{ value: data.Path }];
    //       return newRow;
    //     });
    //   } else if (value != null && value == "LogoPath") {
    //     item.data.value =
    //       formModel["LogoPath"] != null && formModel["LogoPath"].length > 0
    //         ? formModel["LogoPath"][0].Path
    //         : "";
    //   } else {
    //     item.data.value = formModel[value];
    //   }
    //   if (item.template.label == "ประเภทสินค้า/บริการ") {
    //     let arrayService: string[] = [];
    //     formModel["ServiceAndItem"]?.forEach((data: any) => {
    //       arrayService.push(data.ServiceItemID);
    //     });
    //     item.data.value = arrayService.join() ?? "";
    //   }
    //   return item;
    // });
    // const openForm = await OpenApiMemorandumSeller(resultOpenApi);
    // if (openForm) {
    //   if (permissionData?.isAuthenticated && permissionData.isAdmin) {
    //     Swal.fire({
    //       title: "ส่งข้อมูลสำเร็จ",
    //       icon: "success",
    //       confirmButtonText: `ยืนยัน`,
    //       confirmButtonColor: "#6598F6",
    //     }).then(() => {
    //       history.push("/Supplierlist");
    //     });
    //   } else if (permissionData?.isAuthenticated && permissionData.isSeller) {
    //     Swal.fire({
    //       title: "ส่งข้อมูลสำเร็จ",
    //       icon: "success",
    //       confirmButtonText: `ยืนยัน`,
    //       confirmButtonColor: "#6598F6",
    //     }).then(() => {
    //       history.go(0);
    //     });
    //   } else {
    //     formModel.ExceptionDetail = formModel.ExceptionDetail?.map(
    //       (data: any) => data.Path
    //     );
    //     formModel.Certificate = formModel.Certificate?.map(
    //       (data: any) => data.Path
    //     );
    //     formModel.CertOfCompletion = formModel.CertOfCompletion?.map(
    //       (data: any) => data.Path
    //     );
    //     formModel.LogoPath =
    //       formModel.LogoPath != null && formModel.LogoPath.length > 0
    //         ? formModel.LogoPath[0].Path
    //         : "";
    //     formModel.CatalogFilePath = formModel.CatalogFilePath?.map(
    //       (data: any) => data.Path
    //     );

    //     const resultSave = await SaveUserToDatabase(formModel, "Individual");
    //     if (resultSave.code !== "200") {
    //       Swal.fire({
    //         icon: "error",
    //         title: resultSave.message,
    //         confirmButtonText: `ยืนยัน`,
    //         confirmButtonColor: "#6598F6",
    //       });
    //     } else {
    //       Swal.fire({
    //         title: "ส่งข้อมูลสำเร็จ",
    //         icon: "success",
    //         confirmButtonText: `ยืนยัน`,
    //         confirmButtonColor: "#6598F6",
    //       }).then((result) => {
    //         if (result.isConfirmed) {
    //           permissionData.isAuthenticated && permissionData.isSeller
    //             ? history.go(0)
    //             : history.push("/login");
    //         }
    //       });
    //     }
    //   }
    // } else {
    //   Swal.fire({
    //     title: "ส่งข้อมูลไม่สำเร็จ",
    //     icon: "error",
    //     confirmButtonText: `ยืนยัน`,
    //     confirmButtonColor: "#6598F6",
    //   });
    // }
  };

  //**Confirm form */
  const onsubmit = async (data: any) => {
    Swal.fire({
      title: "กำลังส่งข้อมูลข้อมูล...",
      text: "กรุณารอสักครู่...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    if (data.ServiceAndItem && data.ServiceAndItem?.length > 0) {
      if (data.ServiceAndItem[0].ServiceItemID != undefined) {
        data.ServiceAndItem = data.ServiceAndItem.map((item: any) => {
          if (item.OtherService != null) {
            return { ServiceItemID: item.OtherService };
          } else {
            return { ServiceItemID: item.ServiceItemID };
          }
        });
      } else {
        data.ServiceAndItem = [];
      }
    }
    let formModel: any = {
      SellerStatus:
        permissionData.isAuthenticated && sellerDetail
          ? data.SellerStatus
          : "Pending",
      SellerType: "บุคคลธรรมดา",
      SellerNameTh: data.SellerNameTh,
      SellerRegisterType: data.SellerRegisterType,
      TaxpayerIdentificationNo: data.TaxpayerIdentificationNo,
      BussniesType: data.BussniesType,
      IdentificationNo: data.IdentificationNo,
      MobilePhone: data.MobilePhone,
      Region: data.Region,
      Buildings: data.Buildings,
      Room: data.Room,
      Floor: data.Floor,
      Village: data.Village,
      HouseNo: data.HouseNo,
      Swine: data.Swine,
      Alley: data.Alley,
      Road: data.Road,
      Province: data.Province,
      Districe: data.Districe,
      State: data.State,
      Post: data.Post,
      ContactName: data.ContactName,
      PhoneNumber: `${data.PhoneNumber}${data?.Per?.length > 0 ? " ต่อ " + data?.Per : ""
        }`,
      Email: data.Email,
      DigitalContact: data.DigitalContact,
      ExceptionDetail: data.ExceptionDetail,
      Certificate: data.Certificate,
      CertOfCompletion: data.CertOfCompletion,
      LogoPath: data.LogoPath ? data.LogoPath[0] : "",
      ServiceAndItem: data.ServiceAndItem,
      OtherService: data.OtherService,
      CatalogFilePath: data.CatalogFilePath,
      Mode: permissionData?.isAuthenticated ? "Update" : "Register",
      SellerCode: permissionData.isAuthenticated
        ? sellerDetail?.EmployeeCode
        : "",
      Capital: permissionData.isAuthenticated ? data.deliveryDate?.capital : "",
      Provincial: permissionData.isAuthenticated
        ? data.deliveryDate?.provincial
        : "",
    };
    const isCheckBlackList = await checkBlackList(formModel);
    if (isCheckBlackList) {
      if (!permissionData?.isAuthenticated) {
        const response = await requestOTPAndSaveToDb({
          TelMobile: formModel.MobilePhone,
        });
        if (response.code === "200") {
          setConfirmOTP(response?.data);
          setDataOTP(formModel);
          setTimeout(() => {
            Swal.close();
            setShowModalOtp(true);
          }, 1000);
        } else {
          setTimeout(() => {
            Swal.fire({
              title: "ส่ง OTP ไม่สำเร็จ",
              icon: "error",
              confirmButtonText: `ยืนยัน`,
              confirmButtonColor: "#6598F6",
            });
          }, 1000);
        }
      } else {
        submitAndOpenForm(formModel);
      }
    } else {
      Swal.close();
    }
  };

  const checkBlackList = async (formData: FormRegister): Promise<boolean> => {
    let check = true;
    if (permissionData.isAuthenticated && permissionData.isAdmin) {
      check = true;
    } else {
      let response = await CheckBlackListForm(formData, "Individual");
      if (response.data) {
        if (
          response.data.supplierType === "Individual" &&
          response.data.blacklist.length > 0
        ) {
          setShowDailogBlackList(true);
          check = false;
        }
      }
    }
    return check;
  };

  const onOk = () => {
    cancelDailog();
    setTimeout(() => {
      setErrosSize(initailErrors);
      handleSubmit(onsubmit)();
    }, 300);
  };

  //**File Upload */
  const onChangeFile = (
    e: React.ChangeEvent<HTMLInputElement>,
    key: keyof FIleUpload
  ) => {
    const files = e.currentTarget.files;
    if (files && files.length > 0) {
      const newValue: Files[] = Array.from(files).map((file) => {
        return { name: file.name, file: file };
      });
      setFileList((prevState: FIleUpload) => ({
        ...prevState,
        [key]: newValue,
      }));
    }
  };

  const showFileList = (params: Partial<FIleUpload>) => {
    setshowFiles((prev) => ({
      ...prev,
      ...params,
    }));
  };

  const showSizeErrors = (params: Partial<ErrosFIleUpload>) => {
    setErrosSize((prev) => ({
      ...prev,
      ...params,
    }));
  };

  const uploadFileHandler = (key: keyof FIleUpload) => {
    const files = fileList[key];
    console.log(files);
    let showFile: Files[] = [];
    if (key !== "LogoPath") {
      showFile = [...showFiles[key]];
    }
    let errors: Errors[] = [];
    let value: string[] = [];
    const maxSize = key === "LogoPath" || key === "CatalogFilePath" ? 20 : 2;
    const fileExtension = ["pdf", "jpg", "jpeg", "png", "docx", "doc"];
    if (files.length > 0) {
      files.forEach((file: any, i) => {
        const fileSizeMB = file.file && file.file?.size / 1024 / 1024;
        const includeFileExtension =
          file.file &&
          fileExtension.includes(file.name.split(".").pop().toLowerCase());
        if (fileSizeMB && fileSizeMB < maxSize && includeFileExtension) {
          showFile.push(file);
        } else if (!includeFileExtension) {
          errors.push({
            type: "validate",
            message: `ไม่สามารถอัพโหลดไฟล์ ${file.name} ได้`,
          });
        } else {
          errors.push({
            type: "validate",
            message: `ขนาดไฟล์ ${file.name} มากกว่าที่กำหนด`,
          });
        }
      });
    }
    showFile.forEach((data) => {
      value.push(data.name);
    });
    setValue(`${key}`, value);
    showFileList({ [key]: showFile });
    showSizeErrors({ [key]: errors });
    setFileList((prevState: FIleUpload) => ({
      ...prevState,
      [key]: [],
    }));
  };

  const deleteFileUpload = (key: keyof FIleUpload, name: string) => {
    const files = showFiles[key];
    let value: string[] = [];
    let showFile: Files[] = [];
    if (files.length > 0) {
      const newFile = files.filter((file) => file.name !== name);
      newFile.forEach((file) => {
        value.push(file.name);
        showFile.push(file);
      });
    }
    showFileList({ [key]: showFile });
    setValue(`${key}`, value);
  };

  const uploadFile = async (key: keyof FIleUpload) => {
    let results: any[] = [];
    if (showFiles[key] && showFiles[key].length > 0) {
      for (const item of showFiles[key]) {
        if (
          sellerDetail &&
          Array.isArray(sellerDetail[key]) &&
          sellerDetail[key].length > 0
        ) {
          for (let seller of sellerDetail[key]) {
            if (item.name === seller) {
              console.log("item.name = ", item.name);
              console.log("seller = ", seller);
            } else {
              const formData = new FormData();
              if (item.file) {
                formData.append("files", item.file);
                formData.append("Doclib", "TempAttachment");
                formData.append("docSet", generateQuickGuid());
                formData.append("fileDesc", `Upload file ${item.name}`);
                formData.append("actorID", "1");

                // Log each formData entry
                console.log(
                  `Form Data for ${item.name}:`,
                  [...formData.entries()]
                    .map((entry) => `${entry[0]}: ${entry[1]}`)
                    .join(", ")
                );
                const response = await UploadFileAttachFiles_v2(formData);
                results.push(response?.data);
              }
            }
          }
        } else {
          const formData = new FormData();
          if (item.file) {
            formData.append("files", item.file);
            formData.append("Doclib", "TempAttachment");
            formData.append("docSet", generateQuickGuid());
            formData.append("fileDesc", `Upload file ${item.file.name}`);
            formData.append("actorID", "1");
            //**Log list file upload */
            for (var pair of formData.entries()) {
              console.log(`Form Data[${key}] = `, pair[0] + ": " + pair[1]);
            }
            const response = await UploadFileAttachFiles_v2(formData);
            results.push(response?.data);
          }
        }
      }
    }
    console.log("results = ", results);
    return results;
  };
  const upload = async (data: any) => {
    const responseFilePath = {
      ExceptionDetail: [] as any[],
      Certificate: [] as any[],
      CertOfCompletion: [] as any[],
      LogoPath: [] as any[],
      CatalogFilePath: [] as any[],
    };
    try {
      if (data?.ExceptionDetail) {
        if (
          sellerDetail?.ExceptionDetail != null &&
          sellerDetail?.ExceptionDetail.length > 0
        ) {
          for (let item of data.ExceptionDetail) {
            if (sellerDetail?.ExceptionDetail?.includes(item)) {
              responseFilePath.ExceptionDetail.push({
                result: true,
                pathUrl: item,
                fileName: item,
              });
            }
          }
          const result = await uploadFile("ExceptionDetail");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.ExceptionDetail.push(uploadedItem);
            });
          }
        } else {
          const result = await uploadFile("ExceptionDetail");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.ExceptionDetail.push(uploadedItem);
            });
          }
        }
      }
      if (data?.Certificate) {
        if (
          sellerDetail?.Certificate != null &&
          sellerDetail?.Certificate.length > 0
        ) {
          for (let item of data.Certificate) {
            if (sellerDetail?.Certificate?.includes(item)) {
              responseFilePath.Certificate.push({
                result: true,
                pathUrl: item,
                fileName: item,
              });
            }
          }
          const result = await uploadFile("Certificate");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.Certificate.push(uploadedItem);
            });
          }
        } else {
          const result = await uploadFile("Certificate");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.Certificate.push(uploadedItem);
            });
          }
        }
      }
      if (data?.CertOfCompletion) {
        if (
          sellerDetail?.CertOfCompletion != null &&
          sellerDetail?.CertOfCompletion.length > 0
        ) {
          for (let item of data.CertOfCompletion) {
            if (sellerDetail?.CertOfCompletion?.includes(item)) {
              responseFilePath.CertOfCompletion.push({
                result: true,
                pathUrl: item,
                fileName: item,
              });
            }
          }
          const result = await uploadFile("CertOfCompletion");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.CertOfCompletion.push(uploadedItem);
            });
          }
        } else {
          const result = await uploadFile("CertOfCompletion");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.CertOfCompletion.push(uploadedItem);
            });
          }
        }
      }
      if (data?.LogoPath) {
        if (sellerDetail?.LogoPath != null) {
          if (sellerDetail?.LogoPath?.includes(data?.LogoPath)) {
            responseFilePath.LogoPath.push({
              result: true,
              pathUrl: item,
              fileName: item,
            });
          }
          const result = await uploadFile("LogoPath");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.LogoPath.push(uploadedItem);
            });
          }
        } else {
          const result = await uploadFile("LogoPath");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.LogoPath.push(uploadedItem);
            });
          }
        }
      }
      if (data?.CatalogFilePath) {
        if (sellerDetail?.CatalogFilePath != null) {
          if (sellerDetail?.CatalogFilePath?.includes(data?.CatalogFilePath)) {
            responseFilePath.CatalogFilePath.push({
              result: true,
              pathUrl: item,
              fileName: item,
            });
          }
          const result = await uploadFile("CatalogFilePath");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.CatalogFilePath.push(uploadedItem);
            });
          }
        } else {
          const result = await uploadFile("CatalogFilePath");
          if (result) {
            result.forEach((uploadedItem) => {
              responseFilePath.CatalogFilePath.push(uploadedItem);
            });
          }
        }
      }
    } catch (err: any) {
      console.error(`Upload File ${err}`);
    }

    console.log("responseFilePath = ", JSON.stringify(responseFilePath));
    return responseFilePath;
  };

  const cancelDailogBlackList = useCallback(() => {
    setShowDailogBlackList(false);
  }, []);

  const itemOptions = (i: number) => {
    const filterCategory = item?.filter(
      (it) => it.category === watch(`ServiceAndItem.${i}.ServiceItemType`)
    );
    const groupByType = filterCategory?.reduce(
      (
        acc: {
          [key: string]: {
            label: string;
            options: { label: string; value: string }[];
          };
        },
        currentItem
      ) => {
        if (!acc[currentItem.type]) {
          acc[currentItem.type] = {
            label: currentItem.type,
            options: [],
          };
        }
        acc[currentItem.type].options.push({
          label: currentItem.label,
          value: currentItem.label,
        });
        return acc;
      },
      {} as {
        [key: string]: {
          label: string;
          options: { label: string; value: string }[];
        };
      }
    );

    const filterValue = groupByType ? Object.values(groupByType) : [];

    return filterValue;
  };

  const onCloseOTP = useCallback(() => {
    setShowModalOtp(false);
  }, []);

  const onOkOTP = (isOtpCorrect: boolean) => {
    if (isOtpCorrect && dataOTP) {
      onCloseOTP();
      setTimeout(() => {
        Swal.fire({
          title: "กำลังส่งข้อมูลข้อมูล...",
          text: "กรุณารอสักครู่...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        submitAndOpenForm(dataOTP);
      }, 200);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onsubmit)}>
        <div style={{ display: "grid", rowGap: "20px" }}>
          <div style={{ borderRadius: "8px" }}>
            <div className="container-input">
              <div className="header-content">
                บันทึกข้อมูลผู้ค้าบุคคลธรรมดา
              </div>
              <div className="content-form">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "0.5fr 1.5fr",
                    gridTemplateRows: "auto",
                    rowGap: "8px",
                    justifyContent: "space-between",
                  }}
                >
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ชื่อผู้ประกอบการ/ชื่อร้านค้า
                  </label>
                  <div>
                    <input
                      type="text"
                      className={`${errors.SellerNameTh && "error-input"}`}
                      {...register("SellerNameTh", {
                        required: "ชื่อผู้ประกอบการ/ชื่อร้านค้า",
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    {errors.SellerNameTh && (
                      <p className="error-message">
                        {errors.SellerNameTh.message}
                      </p>
                    )}
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    เลขประจำตัวผู้เสียภาษีอากร
                  </label>
                  <div>
                    <input
                      type="text"
                      maxLength={13}
                      className={`${errors.TaxpayerIdentificationNo && "error-input"
                        }`}
                      {...register("TaxpayerIdentificationNo", {
                        required: "กรุณากรอกเลขประจำตัวผู้เสียภาษีอากร",
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    {errors.TaxpayerIdentificationNo && (
                      <p className="error-message">
                        {errors.TaxpayerIdentificationNo.message}
                      </p>
                    )}
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ประเภทผู้ค้า
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "bold",
                    }}
                  >
                    <div>
                      <Controller
                        name="SellerRegisterType"
                        control={control}
                        rules={{ required: "กรุณาเลือกประเภทผู้ค้า" }}
                        render={({ field }) => (
                          <Radio.Group
                            className={`${errors.SellerRegisterType && "error-input"
                              }`}
                            disabled={
                              permissionData.isAuthenticated &&
                              !permissionData.isSeller
                            }
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                          >
                            <Radio
                              value={"คณะบุคคล"}
                              style={{ fontSize: "1.1rem" }}
                            >
                              คณะบุคคล
                            </Radio>
                            <Radio
                              value={"ห้างหุ้นส่วนสามัญ"}
                              style={{ fontSize: "1.1rem" }}
                            >
                              ห้างหุ้นส่วนสามัญ
                            </Radio>
                            <Radio
                              value={
                                "กิจการร้านค้าเจ้าของคนเดียวหรือบุคคลธรรมาดา"
                              }
                              style={{ fontSize: "1.1rem" }}
                            >
                              กิจการร้านค้าเจ้าของคนเดียวหรือบุคคลธรรมาดา
                            </Radio>
                          </Radio.Group>
                        )}
                      />
                      {errors.SellerRegisterType && (
                        <p className="error-message">
                          {errors.SellerRegisterType.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ประเภทกิจการ
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "bold",
                    }}
                  >
                    <div>
                      <Controller
                        name="BussniesType"
                        control={control}
                        rules={{ required: "กรุณาเลือกประเภทกิจการ" }}
                        render={({ field }) => {
                          return (
                            <Radio.Group
                              className={`${errors.BussniesType && "error-input"
                                }`}
                              disabled={
                                permissionData.isAuthenticated &&
                                !permissionData.isSeller
                              }
                              value={field.value}
                              onChange={(e) => field.onChange(e.target.value)}
                            >
                              <Radio
                                value={"ผลิต"}
                                style={{ fontSize: "1.1rem" }}
                              >
                                ผลิต
                              </Radio>
                              <Radio
                                value={"ส่งออก"}
                                style={{ fontSize: "1.1rem" }}
                              >
                                ส่งออก
                              </Radio>
                              <Radio
                                value={"ขายส่ง"}
                                style={{ fontSize: "1.1rem" }}
                              >
                                ขายส่ง
                              </Radio>
                              <Radio
                                value={"ขายปลีก"}
                                style={{ fontSize: "1.1rem" }}
                              >
                                ขายปลีก
                              </Radio>
                              <Radio
                                value={"ให้บริการ"}
                                style={{ fontSize: "1.1rem" }}
                              >
                                ให้บริการ
                              </Radio>
                            </Radio.Group>
                          );
                        }}
                      />
                      {errors.BussniesType && (
                        <p className="error-message">
                          {errors.BussniesType.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    เลขประจำตัวประชาชน
                  </label>
                  <div>
                    <input
                      type="text"
                      maxLength={13}
                      className={`${errors.IdentificationNo && "error-input"}`}
                      {...register("IdentificationNo", {
                        required: "กรุณากรอกเลขประจำตัวประชาชน",
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    {errors.IdentificationNo && (
                      <p className="error-message">
                        {errors.IdentificationNo.message}
                      </p>
                    )}
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    หมายเลขโทรศัพท์ <br />
                    (เพื่อใช้ยืนยันตัวตน)
                  </label>
                  <div>
                    <input
                      type="text"
                      className={`${errors.MobilePhone && "error-input"}`}
                      {...register("MobilePhone", {
                        required: "กรุณากรอกเบอร์มือถือสำหรับยืนยันตัวตน",
                        pattern: {
                          value:
                            /^(\+?\d{1,3})?(0\d{8,9})$/,
                          message: "กรุณากรอกเบอร์มือถือให้ถูกต้อง",
                        },
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                      maxLength={10}
                    />
                    {errors.MobilePhone && (
                      <p className="error-message">
                        {errors.MobilePhone.message}
                      </p>
                    )}
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ที่ตั้งสำนักงานใหญ่
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "bold",
                    }}
                  >
                    <div>
                      <Controller
                        name="Region"
                        control={control}
                        rules={{ required: "กรุณาเลือกที่ตั้งสำนักงานใหญ่" }}
                        render={({ field }) => (
                          <Radio.Group
                            className={`${errors.Region && "error-input"}`}
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            disabled={
                              permissionData.isAuthenticated &&
                              !permissionData.isSeller
                            }
                          >
                            <Radio
                              value={"ประเทศไทย"}
                              style={{ fontSize: "1.1rem" }}
                            >
                              ประเทศไทย
                            </Radio>
                            <Radio
                              value={"ต่างประเทศ"}
                              style={{ fontSize: "1.1rem" }}
                            >
                              ต่างประเทศ
                            </Radio>
                          </Radio.Group>
                        )}
                      />
                      {errors.Region && (
                        <p className="error-message">{errors.Region.message}</p>
                      )}
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    ชื่ออาคาร
                  </label>
                  <input
                    type="text"
                    {...register("Buildings")}
                    disabled={
                      permissionData.isAuthenticated && !permissionData.isSeller
                    }
                  />
                  <label htmlFor="" className="label">
                    ห้องเลขที่
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <input
                      type="text"
                      {...register("Room")}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <label htmlFor="" className="label">
                        ชั้นที่
                      </label>
                      <input
                        type="text"
                        style={{ maxWidth: "80%" }}
                        {...register("Floor")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    ชื่อหมู่บ้าน
                  </label>
                  <input
                    type="text"
                    {...register("Village")}
                    disabled={
                      permissionData.isAuthenticated && !permissionData.isSeller
                    }
                  />
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    เลขที่
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <input
                        type="text"
                        className={`${errors.HouseNo && "error-input"}`}
                        {...register("HouseNo", {
                          required: "กรุณากรอกบ้านเลขที่",
                        })}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      {errors.HouseNo && (
                        <p className="error-message">
                          {errors.HouseNo.message}
                        </p>
                      )}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <label htmlFor="" className="label">
                        หมู่ที่
                      </label>
                      <input
                        type="text"
                        style={{ maxWidth: "80%" }}
                        {...register("Swine")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ตรอก/ซอย
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      {" "}
                      <input
                        type="text"
                        className={`${errors.Alley && "error-input"}`}
                        {...register("Alley", {
                          required: "กรุณากรอก ตรอก/ซอย",
                        })}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      {errors.Alley && (
                        <p className="error-message">{errors.Alley.message}</p>
                      )}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <label htmlFor="" className="label">
                        ถนน
                      </label>
                      <input
                        type="text"
                        style={{ maxWidth: "80%" }}
                        {...register("Road")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    จังหวัด
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <Controller
                        name="Province"
                        control={control}
                        rules={{ required: "กรุณาเลือกจังหวัด" }}
                        render={({ field }) => {
                          return (
                            <Select
                              {...field}
                              className={`${errors.Province && "error-input"}`}
                              style={{ width: 120 }}
                              allowClear
                              disabled={
                                permissionData.isAuthenticated &&
                                !permissionData.isSeller
                              }
                              options={
                                provinces?.map((p) => {
                                  return {
                                    value: p.Province,
                                    label: p.Province,
                                  };
                                }) || []
                              }
                            />
                          );
                        }}
                      />
                      {errors.Province && (
                        <p className="error-message">
                          {errors.Province.message}
                        </p>
                      )}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <label htmlFor="" className="label">
                        <span style={{ color: "red" }}>*&nbsp;</span>
                        อำเภอ/เขต
                      </label>

                      <Controller
                        name="Districe"
                        control={control}
                        rules={{ required: "กรุณาเลือก อำเภอ/เขต" }}
                        render={({ field }) => {
                          return (
                            <div style={{ width: "70%" }}>
                              <Select
                                {...field}
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                className={`${errors.State && "error-input"}`}
                                allowClear
                                options={
                                  distrinces?.map((d) => {
                                    return {
                                      label: d.Districe,
                                      value: d.Districe,
                                    };
                                  }) || []
                                }
                              />
                              {errors.State && (
                                <p className="error-message">
                                  {errors.State.message}
                                </p>
                              )}
                            </div>
                          );
                        }}
                      />
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ตำบล/แขวง
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <Controller
                      name="State"
                      control={control}
                      rules={{ required: "กรุณาเลือก ตำบล/แขวง" }}
                      render={({ field }) => {
                        return (
                          <div>
                            <Select
                              {...field}
                              disabled={
                                permissionData.isAuthenticated &&
                                !permissionData.isSeller
                              }
                              style={{ width: "100%" }}
                              className={`${errors.Districe && "error-input"}`}
                              allowClear
                              options={
                                statees?.map((s) => {
                                  return { label: s.State, value: s.State };
                                }) || []
                              }
                            />
                            {errors.Districe && (
                              <p className="error-message">
                                {errors.Districe.message}
                              </p>
                            )}
                          </div>
                        );
                      }}
                    />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <label htmlFor="" className="label">
                        <span style={{ color: "red" }}>*&nbsp;</span>
                        รหัสไปรษณีย์
                      </label>

                      <div style={{ width: "70%" }}>
                        <input
                          type="number"
                          readOnly
                          className={`${errors.Post && "error-input"}`}
                          {...register("Post", {
                            required: "กรุณากรอกรหัสไปรษณีย์",
                          })}
                          disabled={
                            permissionData.isAuthenticated &&
                            !permissionData.isSeller
                          }
                          value={post}
                          onChange={(e) => {
                            setPost(Number(e.target.value));
                            setValue("Post", JSON.stringify(e.target.value));
                          }}
                        />{" "}
                        {errors.Post && (
                          <p className="error-message">{errors.Post.message}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ชื่อผู้ติดต่อ
                  </label>
                  <div>
                    <input
                      type="text"
                      className={`${errors.ContactName && "error-input"}`}
                      {...register("ContactName", {
                        required: "กรุณากรอกชื่อผู้ติดต่อ",
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    {errors.ContactName && (
                      <p className="error-message">
                        {errors.ContactName.message}
                      </p>
                    )}
                  </div>

                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    หมายเลขโทรศัพท์
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "500px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      <input
                        placeholder="021234567, 051236895"
                        type="text"
                        className={`${errors.PhoneNumber && "error-input"}`}
                        {...register("PhoneNumber", {
                          required: "กรุณากรอกหมายเลขโทรศัพท์",
                          pattern: {
                            value:
                              /^(\+?\d{1,3})?(0\d{8,9})$/,
                            message: "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
                          },
                        })}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                        maxLength={9}
                      />
                      {errors.PhoneNumber && (
                        <p className="error-message">
                          {errors.PhoneNumber.message}
                        </p>
                      )}
                      <p
                        style={{
                          fontSize: "1.1rem",
                          fontWeight: "bold",
                          margin: 0,
                        }}
                      >
                        ต่อ
                      </p>
                      <input
                        type="text"
                        placeholder="123, 56"
                        className={`${errors.PhoneNumber && "error-input"}`}
                        {...register("Per")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        width: "100%",
                      }}
                    >
                      <p style={{ fontSize: "0.9rem", margin: 0 }}>
                        หมายเลขโทรศัพท์ 0-2123-4567 ต่อ 1234
                      </p>
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    e-mail
                  </label>
                  <div>
                    <input
                      type="text"
                      className={`${errors.Email && "error-input"}`}
                      {...register("Email", {
                        required: "กรุณากรอก email",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "กรุณากรอก email ให้ถูกต้อง",
                        },
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    {errors.Email && (
                      <p className="error-message">{errors.Email.message}</p>
                    )}
                  </div>
                  <label htmlFor="" className="label">
                    ช่องทางการประชาสัมพันธ์ <br />
                    (Website ,Facebook, อื่นๆ)
                  </label>
                  <input
                    type="text"
                    {...register("DigitalContact")}
                    disabled={
                      permissionData.isAuthenticated && !permissionData.isSeller
                    }
                  />
                  <label
                    htmlFor=""
                    className="label"
                    style={{ lineHeight: "1" }}
                  >
                    ประวัติการได้รับข้อยกเว้น <br />
                    (ทางกฏหมาย หรือ เอกสิทธิ์พิเศษ ทางกฏหมาย <br />
                    หรือ ประวัติการติดบัญชีรายชื่อผู้ทิ้งงาน)
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "400px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <div
                        style={{
                          minHeight: "90px",
                          border: "1px solid black",
                          borderRadius: "6px",
                          borderColor: "#C5C5C5",
                          padding: "10px",
                        }}
                      >
                        {showFiles.ExceptionDetail?.map((n, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                alignItems: "cemter",
                                gap: "5px",
                                marginBottom: "4px",
                              }}
                            >
                              <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#c95559",
                                  borderColor: "#c95559",
                                }}
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                onClick={() =>
                                  deleteFileUpload("ExceptionDetail", n.name)
                                }
                              >
                                <CloseOutlined
                                  style={{
                                    color: "#ffff",
                                  }}
                                  rev={undefined}
                                />
                              </Button>
                              <div key={i} className="list-file">
                                {i + 1}. {n.name}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {errosSize.ExceptionDetail.length > 0 &&
                        errosSize.ExceptionDetail.map((err, i) => {
                          return (
                            <p key={i} className="error-message">
                              {err.message}
                            </p>
                          );
                        })}
                    </span>
                    <div style={{ position: "relative" }}>
                      <input
                        type="file"
                        multiple
                        onChange={(e) => onChangeFile(e, "ExceptionDetail")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      <Button
                        onClick={() => uploadFileHandler("ExceptionDetail")}
                        style={{
                          position: "absolute",
                          right: 0,
                          backgroundColor: "#6598F6",
                          color: "white",
                          borderRadius: "6px",
                        }}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      >
                        Upload File
                      </Button>
                      <br />
                      <p
                        style={{
                          fontSize: "0.9rem",
                          marginBottom: 0,
                          marginTop: 10,
                        }}
                      >
                        เอกสารต้องแนบเป็นไฟล์ pdf (ขนาดไม่เกิน 2 MB)
                      </p>
                    </div>
                  </div>
                  <label
                    htmlFor=""
                    className="label"
                    style={{ lineHeight: "1" }}
                  >
                    แนบใบรับรอง <br />
                    เช่น Regulation Certified, Certificate, <br />
                    Document, ISO
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "400px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <div
                        style={{
                          minHeight: "90px",
                          border: "1px solid black",
                          borderRadius: "6px",
                          borderColor: "#C5C5C5",
                          padding: "10px",
                        }}
                      >
                        {showFiles.Certificate?.map((n, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                alignItems: "cemter",
                                gap: "5px",
                                marginBottom: "4px",
                              }}
                            >
                              <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#c95559",
                                  borderColor: "#c95559",
                                }}
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                onClick={() =>
                                  deleteFileUpload("Certificate", n.name)
                                }
                              >
                                <CloseOutlined
                                  style={{
                                    color: "#ffff",
                                  }}
                                  rev={undefined}
                                />
                              </Button>
                              <div key={i} className="list-file">
                                {i + 1}. {n.name}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {errosSize.Certificate.length > 0 &&
                        errosSize.Certificate.map((err, i) => {
                          return (
                            <p key={i} className="error-message">
                              {err.message}
                            </p>
                          );
                        })}
                    </span>
                    <div style={{ position: "relative" }}>
                      <input
                        type="file"
                        multiple
                        onChange={(e) => onChangeFile(e, "Certificate")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      <Button
                        onClick={() => uploadFileHandler("Certificate")}
                        style={{
                          position: "absolute",
                          right: 0,
                          backgroundColor: "#6598F6",
                          color: "white",
                          borderRadius: "6px",
                        }}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      >
                        Upload File
                      </Button>
                      <br />
                      <p
                        style={{
                          fontSize: "0.9rem",
                          marginBottom: 0,
                          marginTop: 10,
                        }}
                      >
                        เอกสารต้องแนบเป็นไฟล์ pdf (ขนาดไม่เกิน 2 MB)
                      </p>
                    </div>
                  </div>
                  <label htmlFor="" className="label">
                    แบบหนังสือรับรองผลงาน
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "400px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <div
                        style={{
                          minHeight: "90px",
                          border: "1px solid black",
                          borderRadius: "6px",
                          borderColor: "#C5C5C5",
                          padding: "10px",
                        }}
                      >
                        {showFiles.CertOfCompletion?.map((n, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                alignItems: "cemter",
                                gap: "5px",
                                marginBottom: "4px",
                              }}
                            >
                              <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#c95559",
                                  borderColor: "#c95559",
                                }}
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                onClick={() =>
                                  deleteFileUpload("CertOfCompletion", n.name)
                                }
                              >
                                <CloseOutlined
                                  style={{
                                    color: "#ffff",
                                  }}
                                  rev={undefined}
                                />
                              </Button>
                              <div key={i} className="list-file">
                                {i + 1}. {n.name}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {errosSize.CertOfCompletion.length > 0 &&
                        errosSize.CertOfCompletion.map((err, i) => {
                          return (
                            <p key={i} className="error-message">
                              {err.message}
                            </p>
                          );
                        })}
                    </span>
                    <div style={{ position: "relative" }}>
                      <input
                        type="file"
                        multiple
                        onChange={(e) => onChangeFile(e, "CertOfCompletion")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      <Button
                        onClick={() => uploadFileHandler("CertOfCompletion")}
                        style={{
                          position: "absolute",
                          right: 0,
                          backgroundColor: "#6598F6",
                          color: "white",
                          borderRadius: "6px",
                        }}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      >
                        Upload File
                      </Button>
                      <br />
                      <p
                        style={{
                          fontSize: "0.9rem",
                          marginBottom: 0,
                          marginTop: 10,
                        }}
                      >
                        เอกสารต้องแนบเป็นไฟล์ pdf (ขนาดไม่เกิน 2 MB)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="content-note" style={{ backgroundColor: "#EFE2E3" }}>
            <p>
              หนังสือรับรองและหนังสือบริคณห์สนธิ&nbsp;
              <span style={{ color: "#C95559" }}>
                (เอกสารแนบต้องรับรองสำเนาถูกต้องลงลายมือชื่อและประทับตรา
                <br />
                โดยเอกสารต้องเป็นไฟล์ pdf และมีขนาดไม่เกิน 2 เมกะไบต์)
              </span>
            </p>
            <p>
              หมายเหตุ
              <br />
              1. รายการที่มี{" "}
              <span style={{ color: "#C95559" }}>ดอกจันสีแดง</span>{" "}
              หมายถึงต้องบันทึกข้อมูล <br />
              2. กรณีเป็นห้างหุ้นส่วนจำกัด ให้แนบไฟล์หนังสือรับรอง
              และรายละเอียดวัตถุประสงค์ <br />
              3. กรณีเป็นบุคคลธรรมดาที่จดทะเบียนกับกระทรวงพาณิชย์
              ให้แนบไฟล์ใบทะเบียนพาณิชย์ <br />
              4. กรณีเป็นบุคคลธรรมดาที่ไม่ได้จดทะเบียนกับกระทรวงพาณิชย์
              ให้แนบไฟล์บัตรประชาชน
            </p>
          </div>
          <div style={{ borderRadius: "8px" }}>
            <div className="container-input" style={{ paddingBottom: "30px" }}>
              <div className="header-content">บันทึกหมวดหมู่สินค้า/บริการ</div>
              <div className="content-form">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "0.5fr 1.5fr",
                    gridTemplateRows: "auto",
                    rowGap: "8px",
                  }}
                >
                  <label htmlFor="" className="label">
                    รูปโลโก้
                  </label>
                  <div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "100px 1fr",
                        columnGap: "20px",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          minHeight: "auto",
                          position: "relative",
                          border: "1px solid #C5C5C5",
                          borderRadius: "6px",
                        }}
                      >
                        {showFiles.LogoPath.length > 0 ? (
                          <>
                            <div
                              style={{
                                backgroundColor: "#f5222d",
                                borderRadius: "50%",
                                border: "1px solid black",
                                padding: "2px",
                                position: "absolute",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 2,
                                right: 0,
                                marginTop: "-7px",
                                marginRight: "-7px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                deleteFileUpload(
                                  "LogoPath",
                                  showFiles.LogoPath[0].name
                                )
                              }
                            >
                              <CloseOutlined
                                style={{
                                  color: "#ffff",
                                }}
                                rev={undefined}
                              />
                            </div>
                            <img
                              src={
                                sellerDetail?.LogoPath &&
                                  sellerDetail?.LogoPath ==
                                  showFiles.LogoPath[0].name
                                  ? `${location.protocol}//${localStorage.getItem("tinyUrl")
                                    ? localStorage.getItem("tinyUrl")
                                    : ""
                                  }${watch(`LogoPath.${0}`)}`
                                  : URL.createObjectURL(
                                    showFiles?.LogoPath[0].file!
                                  )
                              }
                              alt="Uploaded File"
                              style={{
                                width: "100%",
                                height: "100%",
                                position: "absolute",
                                objectFit: "cover",
                                objectPosition: "center",
                                zIndex: 1,
                              }}
                            />
                          </>
                        ) : (
                          <input
                            type="text"
                            style={{ width: "100%", height: "100%" }}
                            disabled={
                              permissionData.isAuthenticated &&
                              !permissionData.isSeller
                            }
                          />
                        )}
                      </div>
                      <div
                        style={{
                          position: "relative",
                          minHeight: "90px",
                        }}
                      >
                        <input
                          type="file"
                          onChange={(e) => onChangeFile(e, "LogoPath")}
                          disabled={
                            permissionData.isAuthenticated &&
                            !permissionData.isSeller
                          }
                        />
                        <Button
                          onClick={() => uploadFileHandler("LogoPath")}
                          disabled={
                            permissionData.isAuthenticated &&
                            !permissionData.isSeller
                          }
                          style={{
                            position: "absolute",
                            right: 0,
                            backgroundColor: "#6598F6",
                            color: "white",
                            borderRadius: "6px",
                          }}
                        >
                          Upload Image
                        </Button>
                        <br />
                        <p style={{ fontSize: "0.9rem", margin: 0 }}>
                          ในรูปแบบ jpg, png (ขนาดไม่เกิน 20 MB)
                        </p>
                      </div>
                    </div>
                    {errosSize.LogoPath.length > 0 &&
                      errosSize.LogoPath.map((err, i) => {
                        return (
                          <p key={i} className="error-message">
                            {err.message}
                          </p>
                        );
                      })}
                  </div>
                  <label htmlFor="" className="label">
                    ประเภทสินค้า/บริการ
                  </label>
                  <div>
                    {serviceField.map((data, i) => {
                      return (
                        <div
                          key={data.id}
                          style={{
                            display: "flex",
                            backgroundColor: "#EEEEEE",
                            padding: "10px 20px 10px 20px",
                            justifyContent: "center",
                            columnGap: "10px",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "column",
                            }}
                          >
                            <div style={{ minWidth: "310px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  flexShrink: 1,
                                  flexGrow: 1,
                                  gap: "6px",
                                }}
                              >
                                <Controller
                                  control={control}
                                  name={`ServiceAndItem.${i}.ServiceItemType`}
                                  render={({
                                    field: { onChange, onBlur, value, ref },
                                  }) => (
                                    <Select
                                      ref={ref}
                                      onBlur={onBlur}
                                      value={value}
                                      style={{
                                        width: 100,
                                        minWidth: 100,
                                        maxWidth: 100,
                                      }}
                                      disabled={
                                        permissionData.isAuthenticated &&
                                        !permissionData.isSeller
                                      }
                                      placeholder="ระบุประเภทสินค้าบริการ"
                                      onChange={(value) => {
                                        onChange(value);
                                        setValue(
                                          `ServiceAndItem.${i}.ServiceItemID`,
                                          undefined
                                        );
                                      }}
                                      allowClear
                                      options={
                                        category?.map((category) => ({
                                          label: category,
                                          value: category,
                                        })) || []
                                      }
                                    />
                                  )}
                                />
                                <Controller
                                  control={control}
                                  name={`ServiceAndItem.${i}.ServiceItemID`}
                                  render={({
                                    field: { onChange, onBlur, value, ref },
                                  }) => (
                                    <Select
                                      ref={ref}
                                      onBlur={onBlur}
                                      value={value}
                                      style={{
                                        width: 300,
                                        minWidth: 300,
                                        maxWidth: 300,
                                      }}
                                      disabled={
                                        permissionData.isAuthenticated &&
                                        !permissionData.isSeller
                                      }
                                      allowClear
                                      placeholder="ระบุสินค้าบริการ"
                                      onChange={(value) => {
                                        onChange(value);
                                      }}
                                      options={itemOptions(i) || []}
                                    />
                                  )}
                                />
                                {
                                  watch(`ServiceAndItem.${i}.ServiceItemID`) != "อื่นๆ" ?
                                    (
                                      <div
                                        style={{
                                          backgroundColor: "#C5C5C5",
                                          padding: "2px 10px 2px 10px",
                                          borderRadius: "6px",
                                          fontSize: "0.9rem",
                                          color: "black",
                                          minWidth: 250,
                                        }}
                                      >
                                        โปรดระบุ เช่น เครื่องอุปโภค/บริโภค
                                      </div>
                                    ) : (
                                      <input
                                        {...register(
                                          `ServiceAndItem.${i}.OtherService`
                                        )}
                                        disabled={
                                          permissionData.isAuthenticated &&
                                          !permissionData.isSeller
                                        }
                                        style={{ minWidth: 250 }}
                                        placeholder="ระบุบริการอื่นๆ"
                                        type="text"
                                        maxLength={250}
                                      />
                                    )}
                              </div>
                            </div>
                          </div>
                          {i === 0 && serviceField.length < 3 && (
                            <Button
                              type="primary"
                              shape="default"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#6598F6",
                                borderColor: "#6598F6",
                                borderRadius: "6px",
                              }}
                              disabled={
                                permissionData.isAuthenticated &&
                                !permissionData.isSeller
                              }
                              onClick={() => {
                                let newService: ServiceAndItem = {
                                  ServiceItemID: undefined,
                                };
                                appenService(newService);
                              }}
                            >
                              <PlusCircleOutlined rev={undefined} />
                            </Button>
                          )}
                          {serviceField.length > 1 &&
                            (i !== 0 || serviceField.length === 3) && (
                              <Button
                                type="primary"
                                shape="default"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#c95559",
                                  borderColor: "#c95559",
                                  borderRadius: "6px",
                                }}
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                onClick={() => {
                                  removeService(i);
                                }}
                              >
                                <DeleteOutlined rev={undefined} />
                              </Button>
                            )}
                        </div>
                      );
                    })}
                  </div>

                  <label htmlFor="" className="label">
                    <span style={{ color: "red" }}>*&nbsp;</span>
                    ข้อมูลสินค้า/บริการ
                  </label>

                  <div>
                    <input
                      type="text"
                      className={`${errors.OtherService && "error-input"}`}
                      {...register("OtherService", {
                        required: "กรุณากรอกข้อมูลสินค้า/บริการ",
                      })}
                      disabled={
                        permissionData.isAuthenticated &&
                        !permissionData.isSeller
                      }
                    />
                    {errors.OtherService && (
                      <p className="error-message">
                        {errors.OtherService.message}
                      </p>
                    )}
                  </div>

                  <label htmlFor="" className="label">
                    แนบไฟล์ Catalog
                  </label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "400px 1fr",
                      columnGap: "20px",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <div
                        style={{
                          minHeight: "90px",
                          border: "1px solid black",
                          borderRadius: "6px",
                          borderColor: "#C5C5C5",
                          padding: "10px",
                        }}
                      >
                        {showFiles.CatalogFilePath?.map((n, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                alignItems: "cemter",
                                gap: "5px",
                                marginBottom: "4px",
                              }}
                            >
                              <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#c95559",
                                  borderColor: "#c95559",
                                }}
                                disabled={
                                  permissionData.isAuthenticated &&
                                  !permissionData.isSeller
                                }
                                onClick={() =>
                                  deleteFileUpload("CatalogFilePath", n.name)
                                }
                              >
                                <CloseOutlined
                                  style={{
                                    color: "#ffff",
                                  }}
                                  rev={undefined}
                                />
                              </Button>
                              <div key={i} className="list-file">
                                {i + 1}. {n.name}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {errosSize.CatalogFilePath.length > 0 &&
                        errosSize.CatalogFilePath.map((err, i) => {
                          return (
                            <p key={i} className="error-message">
                              {err.message}
                            </p>
                          );
                        })}
                    </span>
                    <div style={{ position: "relative" }}>
                      <input
                        multiple
                        type="file"
                        onChange={(e) => onChangeFile(e, "CatalogFilePath")}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      />
                      <Button
                        onClick={() => uploadFileHandler("CatalogFilePath")}
                        style={{
                          position: "absolute",
                          right: 0,
                          backgroundColor: "#6598F6",
                          color: "white",
                          borderRadius: "6px",
                        }}
                        disabled={
                          permissionData.isAuthenticated &&
                          !permissionData.isSeller
                        }
                      >
                        Upload Image
                      </Button>
                      <br />
                      <p style={{ fontSize: "0.9rem", margin: 0 }}>
                        ในรูปแบบ pdf (ขนาดไม่เกิน 20 MB)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {permissionData?.isAuthenticated && (
            <div className="container-input" style={{ paddingBottom: "30px" }}>
              <div className="header-content">สถานะผู้ค้า</div>
              <div
                className="content-form"
                style={{ display: "flex", flexDirection: "column", gap: 10 }}
              >
                <Row align="middle">
                  <Col span={5}>
                    <label htmlFor="" className="label">
                      สถานะผู้ค้า
                    </label>
                  </Col>
                  <Col span={8}>
                    <Controller
                      control={control}
                      name="SellerStatus"
                      render={({ field }) => (
                        <Select
                          {...field}
                          disabled={
                            permissionData?.isAuthenticated &&
                              permissionData?.isSeller
                              ? true
                              : permissionData?.isAuthenticated &&
                                permissionData?.isAdmin
                                ? false
                                : true
                          }
                          placeholder="เลือกสถานะ"
                          options={[
                            { label: "Pending", value: "Pending" },
                            { label: "AVL-A", value: "AVL-A" },
                            { label: "AVL-B", value: "AVL-B" },
                            { label: "AVL-C", value: "AVL-C" },
                            { label: "Blacklist", value: "BlackList" },
                          ]}
                        />
                      )}
                    />
                  </Col>
                </Row>
                <Row align="middle">
                  <Col span={5}>
                    <label htmlFor="" className="label">
                      กำหนดวันส่งสินค้า:
                    </label>
                  </Col>
                  <Col span={19}>
                    <Row gutter={[10, 10]}>
                      <Col span={24}>
                        <Row gutter={5} align="middle" justify="start">
                          <Col span={5}>
                            {permissionData?.isAuthenticated &&
                              permissionData?.isSeller
                              ? false
                              : permissionData?.isAuthenticated &&
                                permissionData?.isAdmin &&
                                watch("SellerStatus") === "AVL-C"
                                ? true
                                : false && (
                                  <span style={{ color: "red" }}>*&nbsp;</span>
                                )}
                            <label htmlFor="">กรุงเทพและปริมณฑล</label>
                          </Col>
                          <Col span={5}>
                            <input
                              {...register("deliveryDate.capital", {
                                required: {
                                  value:
                                    permissionData?.isAuthenticated &&
                                      permissionData?.isSeller
                                      ? false
                                      : permissionData?.isAuthenticated &&
                                        permissionData?.isAdmin &&
                                        watch("SellerStatus") === "AVL-C"
                                        ? true
                                        : false,
                                  message: "กรุณากรอกกรุงเทพและปริมณฑล",
                                },
                                min: {
                                  value:
                                    permissionData?.isAuthenticated &&
                                      permissionData?.isAdmin &&
                                      watch("SellerStatus") === "AVL-C"
                                      ? 1
                                      : "",
                                  message: "กรุงเทพและปริมณฑลต้องมากกว่า 0",
                                },
                              })}
                              disabled={
                                permissionData?.isAuthenticated &&
                                  permissionData?.isSeller
                                  ? true
                                  : permissionData?.isAuthenticated &&
                                    permissionData?.isAdmin &&
                                    watch("SellerStatus") === "AVL-C"
                                    ? false
                                    : true
                              }
                            />
                            {errors.deliveryDate?.capital && (
                              <p className="error-message">
                                {errors.deliveryDate.capital.message}
                              </p>
                            )}
                          </Col>
                          <Col span={2}>วันที่ทำการ</Col>
                        </Row>
                      </Col>
                      <Col span={24}>
                        <Row gutter={5} align="middle" justify="start">
                          <Col span={5}>
                            {permissionData?.isAuthenticated &&
                              permissionData?.isSeller
                              ? false
                              : permissionData?.isAuthenticated &&
                                permissionData?.isAdmin &&
                                watch("SellerStatus") === "AVL-C"
                                ? true
                                : false && (
                                  <span style={{ color: "red" }}>*&nbsp;</span>
                                )}
                            <label htmlFor="">ต่างจังหวัด</label>
                          </Col>
                          <Col span={5}>
                            <input
                              {...register("deliveryDate.provincial", {
                                required: {
                                  value:
                                    permissionData?.isAuthenticated &&
                                      permissionData?.isSeller
                                      ? false
                                      : permissionData?.isAuthenticated &&
                                        permissionData?.isAdmin &&
                                        watch("SellerStatus") === "AVL-C"
                                        ? true
                                        : false,
                                  message: "กรุณากรอกต่างจังหวัด",
                                },
                                min: {
                                  value:
                                    permissionData?.isAuthenticated &&
                                      permissionData?.isAdmin &&
                                      watch("SellerStatus") === "AVL-C"
                                      ? 1
                                      : "",
                                  message: "ต่างจังหวัดต้องมากกว่า 0",
                                },
                              })}
                              disabled={
                                permissionData?.isAuthenticated &&
                                  permissionData?.isSeller
                                  ? true
                                  : permissionData?.isAuthenticated &&
                                    permissionData?.isAdmin &&
                                    watch("SellerStatus") === "AVL-C"
                                    ? false
                                    : true
                              }
                            />
                            {errors.deliveryDate?.provincial && (
                              <p className="error-message">
                                {errors.deliveryDate.provincial.message}
                              </p>
                            )}
                          </Col>
                          <Col span={2}>วันที่ทำการ</Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
          )}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              columnGap: "10px",
            }}
          >
            <Button
              style={{
                height: "60px",
                color: "white",
                width: "200px",
                fontSize: "30px",
                fontWeight: "bold",
                backgroundColor: "#6598F6",
                borderRadius: "6px",
                marginBottom: "80px",
              }}
              onClick={openConfirmDailog}
            >
              บันทึกข้อมูล
            </Button>
            <Button
              style={{
                height: "60px",
                color: "white",
                width: "200px",
                fontSize: "30px",
                fontWeight: "bold",
                borderRadius: "6px",
                backgroundColor: "#C95559",
              }}
              onClick={() => {
                permissionData?.isAuthenticated && permissionData?.isSeller
                  ? history.go(0)
                  : permissionData?.isAuthenticated && permissionData.isAdmin
                    ? history.push("/Supplierlist")
                    : history.push("/");
              }}
            >
              ปิด
            </Button>
          </div>
        </div>
      </form>
      <ConfirmModal
        visible={showDailogConfirm}
        onCancel={cancelDailog}
        onOk={onOk}
      />
      <IndividualBlackListModal
        visible={showDailogBlackList}
        onCancel={cancelDailogBlackList}
      />
      <OTPModal
        visible={showModalOtp}
        onOk={onOkOTP}
        onClose={onCloseOTP}
        confirmOTP={confirmOTP}
      />
    </>
  );
};

export default RegisterIndividualScreen;
